import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Not an admin account");
        return;
      }
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 grain light-field" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md relative z-10">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 font-mono-th text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to store
        </button>
        <div className="glass p-8 md:p-10">
          <div className="w-12 h-12 border border-white/20 flex items-center justify-center mb-6">
            <Lock className="w-5 h-5" />
          </div>
          <p className="font-mono-th text-xs uppercase tracking-[0.3em] text-neutral-500">THRIFTHOUSE</p>
          <h1 className="font-display font-black text-3xl uppercase mt-2">Admin Access</h1>
          <p className="text-neutral-500 text-sm mt-2">Authorized personnel only.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-xs text-neutral-400 mb-2 block">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#13151A] border border-white/10 px-4 py-3.5 text-sm focus:outline-none focus:border-white/30" placeholder="admin@thrifthouse.com" data-testid="admin-email" />
            </div>
            <div>
              <label className="text-xs text-neutral-400 mb-2 block">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#13151A] border border-white/10 px-4 py-3.5 text-sm focus:outline-none focus:border-white/30" placeholder="••••••••" data-testid="admin-password" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-white text-black py-4 font-mono-th text-xs uppercase tracking-[0.2em] font-semibold disabled:opacity-50 hover:bg-neutral-200 transition-colors" data-testid="admin-login-btn">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
